import { Text, VStack } from "native-base";
import React from "react";

import FormButton from "@/components/atoms/FormButton";
import Modal from "@/components/molecules/Modal";

type DeactivateModalProps = {
  isOpen: boolean;
  isSubmiting?: boolean;
  onSubmit: () => void;
  onClose: () => void;
};

const DeactivateModal = ({ isOpen, isSubmiting, onClose, onSubmit }: DeactivateModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      Header="Tem certeza que deseja desativar sua conta?"
      Body={
        <Text py="4" fontSize="md">
          Essa ação não pode ser desfeita
        </Text>
      }
      Footer={
        <VStack w="full">
          <FormButton mt="4" isLoading={isSubmiting} onPress={onSubmit}>
            Desativar
          </FormButton>
          <FormButton
            colorScheme="white"
            textColor="primary.700"
            my="4"
            shadow="2"
            onPress={onClose}>
            Cancelar
          </FormButton>
        </VStack>
      }
    />
  );
};

export default DeactivateModal;
